import request from '@/router/axios'
import env from '@/config/env'
const baseUrl = env.ferryUrl + '/yd-form/v1/'
/**
 * 提交表单
 */
export const updateFormModel = (data) => {
  return request({
    url: baseUrl + 'save-or-update',
    method: 'POST',
    data
  })
}
/**
 * 获取表单列表
 */
export const getFormList = (data) => {
  return request({
    url: baseUrl + 'page',
    method: 'POST',
    data
  })
}
/**
 * 获取表单列表
 */
export const getFormDetail = (id) => {
  return request({
    url: baseUrl + `detail/${id}`,
    method: 'GET'
  })
}
/**
 * 获取表单收集反馈
 */
export const getFormFeedback = (data) => {
  return request({
    url: env.ferryUrl + '/yd-form-record/v1/page',
    method: 'POST',
    data
  })
}
/**
 * 置顶/取消置顶
 */
export const updateFormTop = (data) => {
  return request({
    url: baseUrl + 'top',
    method: 'POST',
    data
  })
}
/**
 * 收集/停止收集
 */
export const updateFormCollect = (data) => {
  return request({
    url: baseUrl + 'collect-or-stop',
    method: 'POST',
    data
  })
}
/**
 * 重命名
 */
export const updateFormName = (data) => {
  return request({
    url: baseUrl + 'rename',
    method: 'POST',
    data
  })
}
/**
 * 删除
 */
export const delForm = (id) => {
  return request({
    url: baseUrl + 'delete/' + id,
    method: 'DELETE'
  })
}
